import { type MouseEvent, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useClientNavigationPushState } from '@alltrails/core/hooks/useClientNavigation';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import { wrapUrlSafe } from '@alltrails/core/utils/wrapUrlSafe';
import { useExperiments } from '@alltrails/experiments';

const isNewTabClick = (event?: MouseEvent) => event && (event.metaKey || event.ctrlKey || event.button === 1);

const useTrailNavigate = () => {
  const experiments = useExperiments();
  const languageRegionCode = useLanguageRegionCode();
  const pushState = useClientNavigationPushState();
  const isMobileBrowser = useSelector((state: { context: { mobileBrowser: boolean } }) => state.context?.mobileBrowser);
  const isTrailPageEnabled = experiments?.['web-explore-trail-page']?.value === 'treatment';

  return useCallback(
    (slug: string, event?: MouseEvent) => {
      if (isMobileBrowser) {
        window.open(wrapUrlSafe(`/${slug}`, languageRegionCode), '_blank');
      } else if (isTrailPageEnabled && !isNewTabClick(event)) {
        pushState(wrapUrlSafe(`/explore/${slug}`, languageRegionCode));
      } else {
        window.open(wrapUrlSafe(`/${slug}`, languageRegionCode), '_blank');
      }
    },
    [isMobileBrowser, isTrailPageEnabled, languageRegionCode, pushState]
  );
};

export default useTrailNavigate;
